import axios from "axios";
import url from "url";
import { ICTG } from "../models/ctg";
import { API_CENTRE } from "./config";
import { apiCallWithAuth } from "../helper/apiManager";

export default class CTGService {
  static async getCTGByCode(code: string) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/CTG/search?Include=*&Code=" + code,
      );
      return data;
    } catch (err) {
      return null;
    }
  }

  static async getCTGById(id : number) {
    try{
        const { data } = await apiCallWithAuth(API_CENTRE + `/api/v1/CTG/search?CTGId=${id}&Include=*`,'get')

        return {
            'error': false,
            'data': data
        };
    }
    catch(err) {
        return {
            'error': true,
            'data': err
        };
    }
  }

  static async getListCTG() {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/CTG/search?Include=*",
      );
      return data;
    } catch (err) {
      return null;
    }
  }

  static async createCTG(ctg: ICTG) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + "/api/v1/CTG",
        "post",
        ctg,
      );
      return {
        err: false,
        data: data,
      };
    } catch (err: any) {
      return {
        err: true,
        data: err,
      };
    }
  }

  static async updateCTG(ctg: ICTG) {
    try {
      const { data } = await apiCallWithAuth(
        API_CENTRE + `/api/v1/CTG/${ctg.id}`,
        "put",
        ctg,
      );

      return {
        err: false,
        data: data,
      };
    } catch (err) {
      return {
        err: true,
        data: err,
      };
    }
  }

}
